import { render, staticRenderFns } from "./NoticeManagement.vue?vue&type=template&id=c0c31e12&scoped=true"
import script from "./NoticeManagement.vue?vue&type=script&lang=js"
export * from "./NoticeManagement.vue?vue&type=script&lang=js"
import style0 from "./NoticeManagement.vue?vue&type=style&index=0&id=c0c31e12&prod&lang=less&scoped=true"
import style1 from "./NoticeManagement.vue?vue&type=style&index=1&id=c0c31e12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c31e12",
  null
  
)

export default component.exports